// 封装 axios
import axios from "axios";
import config from "../config/config";
import { Message } from "element-ui";

const Axios = axios.create({
  baseURL: config.baseUrl,
  timeout: 50000, 
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

// 请求拦截器
Axios.interceptors.request.use(
  (config) => {
    config.headers.Authorization = localStorage.getItem("token");
    // config.headers.Access - Control - Allow - Origin="*"
    // config.headers.cookies= document.cookies.getItem('')
    // config.headers["Access-Control-Allow-Origin"] = "*";
    // 在发送 请求 之前 可以传递一些 参数到 config 中
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 添加响应拦截器
Axios.interceptors.response.use(
  (response) => {
    // 根据http状态码判断请求是否成功
    if (response.status !== 200) {
      // console.log(response.data.msg)
      this.$message.error(response.data.msg);
      return Promise.reject(response.data);
    }
    // 处理下载信息 是下载直接将整个数据返回给前端 方便做文件下载操作
    if (response.config.responseType === "blob") {
      return response;
    }
    // 处理错误信息
    // if (response.status !== 200) {
    //   // console.log(response.data.msg)
    //   this.$message.error(response.data.msg);
    // }

    // 在这里可以对响应的数据进行处理，例如统一处理错误码、格式化数据等
    return response.data;
  },
  (error) => {
    // 处理响应错误
    // if (error.response.status === 401) {
    // 	localStorage.removeItem('Authorization');
    // 	this.$router.push('/userLogin');
    // }
    console.log(error);
    Message.error(error.message)
    return Promise.reject(error);
  }
);

export default Axios;
